export default [
  {
    title: "Inventory",
    customIcon: "InventorySVG",
    children: [
      {
        title: "Products",
        route: "custom-module",
        path: "/custom-module/inventory",
      },
    ],
  },
];
